import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import HomeIcon from "../../../../assets/images/Map/home.svg";
import CapIcon from "../../../../assets/images/Map/cap.svg";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export const getAllLocationsOnMap = (
  markersResidences,
  mapRef,
  locations,
  selectedLocation,
  universityTabControl
) => {
  if (locations.length && mapRef.current) {
    // Tüm rezidanslar için kırmızı marker'ları ekleyin
    const bounds = new mapboxgl.LngLatBounds();
    const bounds2 = new mapboxgl.LngLatBounds();

    locations.forEach((loc) => {
      const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
        `<h3>${
          universityTabControl ? loc?.university_title : loc.campus_name
        }</h3>`
      );

      // marker = new mapboxgl.Marker({ color: "#23416a" })
      const el = document.createElement("div");
      el.style.backgroundImage = !universityTabControl
        ? `url(${HomeIcon})`
        : `url(${CapIcon})`;
      el.style.width = `40px`;
      el.style.height = `40px`;
      el.style.backgroundSize = "100%";
      const lng = parseFloat(
        universityTabControl
          ? loc?.university_longitude
          : loc?.campus_coordinates?.lng
      );
      const lat = parseFloat(
        universityTabControl
          ? loc?.university_latitude
          : loc?.campus_coordinates?.lat
      );
      // Skip locations with missing/invalid coordinates instead of crashing the map
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;

      const marker = new mapboxgl.Marker(el)
        .setLngLat([lng, lat])
        .setPopup(popup)
        .addTo(mapRef.current);
      (universityTabControl ? bounds : bounds2).extend([lng, lat]);

      markersResidences.current.push(marker);
    });

    if (universityTabControl && !bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds, {
        padding: 50, // Kenarlardan boşluk bırakır
        duration: 500,
      });
    } else if (!bounds2.isEmpty()) {
      mapRef.current.fitBounds(bounds2, {
        padding: 50, // Kenarlardan boşluk bırakır
        duration: 500,
      });
    }
  }
};
